import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
const SvgWarningToastifyBig = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    {...props}
    width={39}
    height={39}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    ref={ref}
  >
    <path
      d="M17.877 16.25h3.25v8.125h-3.25V16.25ZM17.875 26h3.25v3.25h-3.25V26Z"
      fill="#F9A000"
    />
    <path
      d="M22.373 6.825A3.247 3.247 0 0 0 19.5 5.1a3.246 3.246 0 0 0-2.873 1.727L4.703 29.354a3.227 3.227 0 0 0 .088 3.198 3.223 3.223 0 0 0 2.783 1.573h23.852c1.15 0 2.192-.588 2.785-1.573a3.233 3.233 0 0 0 .088-3.198L22.373 6.825ZM7.574 30.875 19.5 8.348l11.934 22.527H7.574Z"
      fill="#F9A000"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgWarningToastifyBig);
export default ForwardRef;
